export const RECOMMENDED_ACTION = 'Preliminary Projection';

export const DEFAULT_RECORDS_REVIEWED = 'Records summary';

export const FUTURE_CARE_SIGNAL_HEADLINE = 'Estimated Settlement Value Increase';

export const FUTURE_CARE_SIGNAL = {
    medium: {
        level: 'Moderate to High',
        description: 'Records contain several indicators that future care may affect settlement strategy.'
    },
    low: {
        level: 'Low',
        description: 'Records have limited indication that future care will affect settlement strategy.'
    },
};

export const DEFAULT_RECORDS_SUMMARY = {
    title: 'Summary of Records Reviewed',
    content: 'Records reviewed reflect ongoing treatment, diagnostic imaging, and conservative care with limited sustained improvement.'
};

export const FALLBACK_CARE_CATEGORIES = [
    {
        name: 'Specialist oversight',
        severity: 'high',
        description: 'Chronic spine complaints may support physiatry or orthopedic review.',
    },
    {
        name: 'Diagnostic follow-up',
        severity: 'med',
        description: 'May be relevant if neurological symptoms continue.',
    },
    {
        name: 'Rehabilitation therapy',
        severity: 'high',
        description: 'Ongoing functional complaints and short-lived relief noted.',
    },
    {
        name: 'Pain management eval.',
        severity: 'med',
        description: 'Referral context exists; procedures not yet documented.',
    },
    {
        name: 'Medication management',
        severity: 'med',
        description: 'May apply if chronic pain or spasm symptoms persist.',
    },
];

export const ATTORNEY_NEXT_STEP = {
    title: 'Recomended Route',
    primaryCtaLabel: 'Request Preliminary Life Care Plan',
};

export const RECOMMENDED_ROUTES = [
    {
        key: 'current',
        tag: 'Current',
        tone: 'neutral',
        title: 'Preview only',
        description:
            'Shows risk signal, evidence basis, care categories, and missing records. No cost totals or copy-ready language.',
        bestFor: 'Best for case triage.',
    },
    {
        key: 'recommended',
        tag: 'Recommended',
        tone: 'primary',
        title: 'Preliminary Projection',
        description:
            'Unlocks the structured cost model for settlement strategy, demand drafting support, and mediation prep.',
        bestFor: 'Best for quantifying future medicals.',
    },
    {
        key: 'escalate',
        tag: 'Escalate',
        tone: 'neutral',
        title: 'Certified Plan',
        description:
            'Routes the case for certified life care planner review, signed report, methodology, and expert support.',
        bestFor: 'Best for litigation or high exposure.',
    },
];

export const PREVIEW_DISCLAIMER =
    'Not for attachment to a demand package. This AI-assisted preview is for internal attorney case evaluation only. It is not a certified life care plan, expert report, medical opinion, legal opinion, or substitute for review by a qualified medical or life care planning professional.';
